import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './ProductComplianceMonitoring.css';

const leftVariants = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};
const rightVariants = {
  hidden: { opacity: 0, x: 80 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};

const ProductComplianceMonitoring = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' });
  return (
    <section className="compliance-section" ref={ref}>
      <div className="compliance-container">
        <motion.div
          className="compliance-content"
          variants={leftVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <h2 className="compliance-title">Proactive Compliance Monitoring</h2>
          <p className="compliance-desc">
            Stay ahead of deadlines with automated tracking for visa, passport, and document expiries. Genix HR ensures you're always compliant — no manual reminders needed.
          </p>
        </motion.div>
        <motion.div
          className="compliance-img-box"
          variants={rightVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <img src="/images/Paymentproduct.png" alt="Compliance Monitoring" className="compliance-img" />
        </motion.div>
      </div>
    </section>
  );
};

export default ProductComplianceMonitoring; 